import { Splide } from '@splidejs/splide';
import gsap from 'gsap';

export default () => {
	const sections = document.querySelectorAll('.looks-promo');
	
	sections.forEach(function(section) {
		const sliderWrappers = section.querySelectorAll('.splide');

		sliderWrappers.forEach(function(sliderEl) {
			const slides = sliderEl.querySelectorAll('.splide__slide');
			if (slides.length < 3) return;

			const splide = new Splide( sliderEl, {
				type: 'loop',
				focus: 'center',
				pagination: false,
				arrows: false,
				speed: 400,
				destroy: true,
				drag: 'free',
				
				breakpoints: {
					1023: {
						fixedWidth: '50vw',
						perMove: 1,
						destroy: false
					},
				}
			});

			splide.mount();
		});


		const buttons = section.querySelectorAll('.js-expand-products');

		if (buttons.length && sliderWrappers.length) {
			buttons.forEach(function(btn, index) {
				const col = btn.closest('.looks-promo__col');
				btn.addEventListener('click', (e) => {
					let isActive = col.classList.toggle('is-expanded');

					gsap.to(sliderWrappers[index],
						{
							height: isActive ? 'auto' : 0,
							duration: 0.3
						}
					);
					
				});
			});
		}
	});
}